import firebase from "firebase/app";

import { getCurrentUser } from "./getCurrentUser";

export const getAllActivities = async () => {
  const currentUser = getCurrentUser();

  if (!currentUser) return null;

  const querySnapshot = await firebase
    .firestore()
    .collection("activities")
    .where("userID", "==", currentUser.id)
    .orderBy("date", "desc")
    .get();

  if (querySnapshot.empty) {
    console.info("No matching documents.");
    return [];
  }

  let allActivities = querySnapshot.docs.map((doc) => {
    return {
      ...doc.data(),
      userId: currentUser.id,
    };
  });

  return allActivities;
};
